var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 11.2496V17.4996M14.9934 21.2496H15.0046M15.0003 26.7621H7.42528C3.08778 26.7621 1.27528 23.6621 3.37528 19.8746L7.27528 12.8496L10.9503 6.24961C13.1753 2.23711 16.8253 2.23711 19.0503 6.24961L26.6253 19.8871C28.7253 23.6746 26.9003 26.7746 22.5753 26.7746H15.0003V26.7621Z",
    stroke: "#42BFCC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d24ec1a17129b7b63c7bc95d2bfe5bd4.svg";
export { ForwardRef as ReactComponent };